import { getLocationValues, getFeatures } from '@/components/charts/orr/lib/api';
import { transformToHeatMap, transformFeatures } from '@/components/charts/orr/lib/transformer';
import { getClusterOption } from '@/components/charts/orr/data/cluster';

const options = {
  chart: {
    height: 350,
    type: "heatmap",
  },
  dataLabels: {
    enabled: false,
  },
  colors: ["#008FFB"],
  // colors: ["#F3B415", "#F27036", "#663F59", "#6A6E94", "#4E88B4", "#00A7C6", "#18D8D8", '#A9D794',
  //             '#46AF78', '#A93F55', '#8C5E58', '#2176FF', '#33A1FD', '#7A918D', '#BAFF29'
  //           ],
  title: {
    text: "HeatMap By Location",
  },
  yaxis: {
    labels: {
      offsetX: 70,
    },
  },
  xaxis: {
    type: 'category',
    labels: {},
    axisTicks: {},
  },
  grid: {
    padding: {
      left: 80, // or whatever value that works
      right: 10, // or whatever value that works
    },
  },
};
export default {
  async aInit() {
      
  },
  async aLoadLocationValue({state}, { filters = {type: 'Delay_Minutes'} } = {} ) {
      try {
        const response = await getLocationValues(filters.type);
        const { data } = response;
        const result = transformToHeatMap(data.results, 'location', 'month', 'value');
        options.xaxis.categories = result.categories;
        state.heatmapSeries = result.series;
        state.heatmapOptions = { ...options };
        state.heatmapKey = 'loaded';
        console.log('state.heatmapSeries', result);
        // commit('aSetHeatMap', series);
      } catch(error) {
        console.log('error', error);
        //
      }
  },
  async aLoadFeatures({state}, { filters = {type: 'Delay_Minutes'} } = {} ) {
    try {
      
      const xLabel = "sum__agg_linear_trend__attr_\\stderr\\__chunk_len_5__f_agg_\\max\\";
      const yLabel = "sum__agg_linear_trend__attr_\\intercept\\__chunk_len_5__f_agg_\\max\\";
      // const yLabel = 'sum__skewness';
      
      const response = await getFeatures(xLabel, yLabel);
      const { data } = response;
      const result = transformFeatures(data.results, 'entity', xLabel, yLabel);
      const options = getClusterOption(result.series);
      state.clusterOptions = options;

      // console.log('result', result);
      // console.log('options', options);

      // options.xaxis.categories = result.categories;
      // state.heatmapSeries = result.series;
      // state.heatmapOptions = { ...options };
      // state.heatmapKey = 'loaded';
      // commit('aSetHeatMap', series);
    } catch(error) {
      // console.log('error', error);
      //
    }
}
};
